export default __webpack_public_path__ + "static/media/slide_0.c2c48306.jpg";